export default "__VITE_ASSET__de058318__"